import { Button } from "@mui/material";
import React from "react";
import { isMobile } from "react-device-detect";
import { useNavigate } from "react-router-dom";

const AlphegaHomeBtn = () => {
  const navigate = useNavigate();

  return (
    <Button
      fullWidth={isMobile || (window.innerWidth <= 785 && true)}
      onClick={() => navigate("/alphega_centrale/alphega_home")}
    >
      HOME
    </Button>
  );
};

export default AlphegaHomeBtn;
